import myDetails from "../assets/myDetails.json";

import Header from '../components/Header';
import Footer from '../components/Footer';
import BackBtn from '../components/BackBtn';

function Projects() {

    const page_title = "Projects";

    return (
        <div className='home-main'>
            <div className='sub-sec'>
                <Header title={page_title} />
                <div className='body-grid'>
                    {
                        myDetails?.projects?.map((work) => (
                            <div>
                                <div className="grid-title">{work.title}</div>
                                <hr></hr>
                                <div className="grid-body-sub-title"><span>{work['tech-stack']}</span></div>
                                <div>{work.desc}</div>
                                <div className='sm-btn-cont'>
                                    {
                                        work?.links?.map((link) => (
                                            <div className='sm-cnt-btn sm-link-btn'>
                                                <a href={link[1]} target='_blank' rel="noreferrer" className='link-btn-href'>{link[0]}</a>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        ))
                    }
                </div>
                <BackBtn title={page_title} />
            </div>
            <Footer />
        </div>
    );
}

export default Projects;